<div class="btn-container tabs">
    <div class="pr-tab-btn print-smart"
         [ngClass]="{'active':model !== supplyAcquisitionTypeEnum.NONE && model !== supplyAcquisitionTypeEnum.PURCHASE, 'disabled': isMpsDisabled}"
         bdFxLayoutAlign="shrink center"
         (click)="onPrintSmartShoppingBtnClicked()">
        <div bdFxFlex="0 0 auto" class="print-smart-icon"
             [ngClass]="{'inverse': model !== supplyAcquisitionTypeEnum.NONE && model !== supplyAcquisitionTypeEnum.PURCHASE}">
            <b>MPS</b>
        </div>
        <bd-labeled-select-input class="in-tab" bdFxFlex="1 0 160px"
                                 [values]="tabsValues"
                                 [choices]="tabsChoices"
                                 [(ngModel)]="lastUsedMPSValue"
                                 (ngModelChange)="onPrintSmartShoppingBtnClicked()"
                                 [placeholder]="'MPS'"
                                 [name]="'tabs'"
                                 (click)="$event.stopPropagation();"
                                 [disabled]="isMpsDisabled">
        </bd-labeled-select-input>

    </div>

    <button type="button" class="pr-tab-btn purchase"
            [ngClass]="{'active': model !== supplyAcquisitionTypeEnum.NONE && model === supplyAcquisitionTypeEnum.PURCHASE}"
            (click)="onGeneralShoppingBtnClicked()">
        Kaufen
    </button>
</div>

